import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  logIn,
  createUser,
  isLoggedIn,
  firebaseLogout,
  getClientDataByUid,
} from "services/firebase";

export const login = createAsyncThunk("get/login", ({ email, password }) => logIn(email, password));
export const signup = createAsyncThunk("get/signup", ({ email, password }) =>
  createUser(email, password)
);
export const getLoginedUser = createAsyncThunk("get/isUserLoggedin", async () => isLoggedIn());
export const getClientData = createAsyncThunk("get/getClientData", async (userId) =>
  getClientDataByUid(userId)
);
export const logout = createAsyncThunk("get/logout", async () => firebaseLogout());

const initialState = {
  user: null,
  clientId: "",
  isAuth: false,
  data: null,
  showHistory: false,
  showSomatics: false,
  userLogo: null,
  userFooter: null,
  userHeader: null,
  rate: true,
  showTestInfo: false,
  deviceIds: null,
  devicesConfigs: null,
  cleaningHistoryData: null,
  correctionHistoryData: null,
  calibrationHistoryData: null,
  somaticCellsData: null,
  rateTableData: null,
  testInfoData: null,
  error: null,
  loading: false,
};

const firebaseSlice = createSlice({
  name: "firebase",
  initialState,
  reducers: {
    setClientId: (state, action) => {
      return {
        ...state,
        clientId: action.payload,
      };
    },
    setCleaningHistory: (state, action) => {
      return {
        ...state,
        cleaningHistoryData: action.payload,
      };
    },
    setCalibrationHistory: (state, action) => {
      return {
        ...state,
        calibrationHistoryData: action.payload,
      };
    },
    setCorrectionHistory: (state, action) => {
      return {
        ...state,
        correctionHistoryData: action.payload,
      };
    },
    setRateTable: (state, action) => {
      return {
        ...state,
        rateTableData: action.payload,
      };
    },
    setTestInfo: (state, action) => {
      return {
        ...state,
        testInfoData: action.payload,
      };
    },
    setSomaticCells: (state, action) => {
      const { deviceId, data } = action.payload;
      return {
        ...state,
        somaticCellsData: {
          ...(state.somaticCellsData ? state.somaticCellsData : {}),
          [deviceId]: data,
        },
      };
    },
    setDeviceIds: (state, action) => {
      return {
        ...state,
        deviceIds: action.payload,
      };
    },
    setData: (state, action) => {
      const { deviceId, data } = action.payload;
      return {
        ...state,
        data: {
          ...(state.data ? state.data : {}),
          [deviceId]: data,
        },
      };
    },
    setDevicesConfigs: (state, action) => {
      return {
        ...state,
        devicesConfigs: action.payload,
      };
    },
    resetState: (state) => ({
      ...initialState,
      // isAuth: state.isAuth,
      // user: state.user,
      // clientId: state.clientId,
    }),
  },
  extraReducers: (builder) => {
    builder
      .addCase(login.fulfilled, (state, action) => {
        const { uid, email } = action.payload.user;
        state.user = { uid, email };
        state.isAuth = true;
        state.error = null;
        state.loading = false;
      })
      .addCase(login.rejected, (state, action) => {
        state.user = null;
        state.error = action.error;
        state.loading = false;
      })
      .addCase(login.pending, (state) => {
        state.loading = true;
      })
      .addCase(signup.fulfilled, (state, action) => {
        const {
          user: { uid, email },
          clientId,
        } = action.payload;
        // state.user = { uid, email };
        // state.clientId = clientId;
        // state.isAuth = true;
        state.error = null;
        state.loading = false;
      })
      .addCase(signup.rejected, (state, action) => {
        state.user = null;
        state.error = action.error;
        state.loading = false;
      })
      .addCase(signup.pending, (state) => {
        state.loading = true;
      })
      .addCase(logout.fulfilled, (state) => {
        state.user = null;
        state.isAuth = false;
        state.error = null;
        state.loading = false;
      })
      .addCase(logout.rejected, (state, action) => {
        state.error = action.error;
        state.loading = false;
      })
      .addCase(logout.pending, (state) => {
        state.loading = true;
      })
      .addCase(getLoginedUser.fulfilled, (state, action) => {
        const { uid, email } = action.payload;
        state.user = { uid, email };
        state.isAuth = true;
        state.error = null;
        state.loading = false;
      })
      .addCase(getLoginedUser.rejected, (state, action) => {
        state.error = action.error;
        state.isAuth = false;
        state.loading = false;
      })
      .addCase(getLoginedUser.pending, (state) => {
        state.loading = true;
      })
      .addCase(getClientData.fulfilled, (state, action) => {
        const { clientId, clientData } = action.payload;
        state.clientId = clientId;
        state.userLogo = clientData.userLogo || null;
        state.userFooter = clientData.userFooter || null;
        state.userHeader = clientData.userHeader || null;
        state.rate = clientData.rate !== undefined ? clientData.rate : true;
        state.showHistory = clientData.history || false;
        state.showSomatics = clientData.somatic || false;
        state.showTestInfo = clientData.testInfo || false;
        state.error = null;
        state.loading = false;
      })
      .addCase(getClientData.rejected, (state, action) => {
        state.error = action.error;
        state.loading = false;
      })
      .addCase(getClientData.pending, (state) => {
        state.loading = true;
      });
  },
});

export const firebase = (state) => state.firebase;
export const {
  resetState,
  setClientId,
  setData,
  setDevicesConfigs,
  setCleaningHistory,
  setDeviceIds,
  setCorrectionHistory,
  setCalibrationHistory,
  setSomaticCells,
  setRateTable,
  setTestInfo,
} = firebaseSlice.actions;
export default firebaseSlice.reducer;
